import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './index.module.scss';

export const AdvancedPricing = () => {
  const { t } = useTranslation('fpg-v1');
  return (
    <div className={s.wrapper}>
      <div className={s.inner}>
        <table className={classnames(s.table_standard, 'text_l')}>
          <tbody>
            <tr>
              <td>{t('fpg_pricing.risk_factor')}</td>
              <td>{t('fpg_pricing.low')}</td>
              <td>{t('fpg_pricing.medium')}</td>
              <td>{t('fpg_pricing.high')}</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '70%' })} *</td>
              <td>{t('fpg_pricing.no_fee')}</td>
              <td>{t('fpg_pricing.no_fee')}</td>
              <td>{t('fpg_pricing.no_fee')}</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '40%' })}</td>
              <td>0.65%</td>
              <td>0.95%</td>
              <td>1.50%</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '10%' })}</td>
              <td>1.00%</td>
              <td>1.45%</td>
              <td>{t('fpg_pricing.no_access')}</td>
            </tr>
          </tbody>
        </table>
        <div className={classnames(s.note, 'f-body-regular')}>
          <span>*</span>
          <div>{t('fpg_pricing.note', { percentage: '70%' })}</div>
        </div>
      </div>
    </div>
  );
};
